export const suiteRentalImages = [
  {
    imgNum: 1,
    imgSrc: "SuiteRentals/ClassicSuites/20person/classic_rental20_1.jpg",
    title: "SUITE",
    subTitle: "RENTALS",
    desc: "Impress your ballpark guests with a suite rental. You'll find a range of options and designs that enable you to configure select suites and host groups from 20 people to as many as 500.",
    caption: "20-PERSON CLASSIC SUITE",
    links: [],
  },
  {
    imgNum: 2,
    imgSrc: "SuiteRentals/ClassicSuites/40person/classic_rental40_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "40-PERSON CLASSIC SUITE",
    links: [],
  },
  {
    imgNum: 3,
    imgSrc: "SuiteRentals/HOF/hall-of-fame_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "HALL OF FAME SUITE",
    links: [],
  },
  {
    imgNum: 4,
    imgSrc: "SuiteRentals/PartySuites/Lower/party_lower_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "LOWER PARTY SUITE",
    links: [],
  },
  {
    imgNum: 5,
    imgSrc: "SuiteRentals/PartySuites/Upper/party_upper_1.jpg",
    title: "",
    subTitle: "",
    desc: "",
    caption: "UPPER PARTY SUITE",
    links: [],
  },
];
